import InputField from './inputField';

export default class EmailField extends InputField {
  getType() {
    return 'email';
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/forms/emailField.jsx
 **/